<template>
  <div class="about-momfident">
    <div class="container">
      <div class="row align-items-center container">
        <div class="col-md-5 text-center mb-4 mb-md-0">
          <img
              src="@/assets/images/team/zhenya.png"
              alt="Zhenya Dimitrova"
              class="img-fluid rounded"
          />
        </div>
        <div class="col-md-7 py-5">
          <h5 class="mb-3">
            {{ $t('about-primary-intro') }}
          </h5>
          <p>
            {{ $t('about-primary-paragraph-1') }}
          </p>
          <p>
            {{ $t('about-primary-paragraph-2') }}
          </p>
          <h5>
            {{ $t('about-primary-how-born-title') }}
          </h5>
          <p>
            {{ $t('about-primary-paragraph-3') }}
          </p>
          <p>
            {{ $t('about-primary-paragraph-4') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// No logic required
</script>

<style lang="scss" scoped>
.about-momfident {
  background: linear-gradient(to bottom, #fff, #fdeef2);
  color: $color-purple;

  p {
    font-size: 14px;
    padding: 20px 0 0 0;
    line-height: 1.3;
  }

  img {
    object-fit: cover;
  }
}
</style>
